import React, { PropTypes } from 'react';
import classnames from 'classnames';

export default class GalleryDotCursor extends React.Component {
  static propTypes = {
    currentSlide: PropTypes.number,
    slideCount: PropTypes.number,
    slidesToShow: PropTypes.number,
    slidesToScroll: PropTypes.number,
    goToSlide: PropTypes.func,
  };

  render() {
    const { currentSlide, slideCount, slidesToShow, slidesToScroll, goToSlide } = this.props;
    const styles = {
      wrapper: classnames({
        'gallery--dot-cursor': true,
      }),
    };
    let dots = [];
    for (let i = 0; i <= slideCount - slidesToShow; i += slidesToScroll) {
      const dotStyle = classnames({
        'gallery--dot-cursor--dot': true,
        'gallery--dot-cursor--dot--active': i === currentSlide,
      });
      const goToThatSlide = goToSlide.bind(null, i);

      dots.push(
        <div className={dotStyle} key={`gallery--dot-cursor--dot-${i}`} onClick={goToThatSlide} />
      );
    }
    return (
      <div className={styles.wrapper}>
        {dots}
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./web/js/components/Gallery/GalleryDotCursor.jsx
 **/